<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__top">
        <div class="footer__brand">
          <router-link to="/" class="footer__logo" aria-label="Allading home">
            <img :src="icon" alt="" width="32" height="32" />
            <span>Allading</span>
          </router-link>
          <p class="footer__tagline">
            Chats, voice notes and calls. Choose secure chats for end-to-end
            encrypted messages.
          </p>
        </div>

        <div class="footer__cols">
          <div class="footer__col">
            <h2 class="footer__heading">Product</h2>
            <router-link :to="{ path: '/', hash: '#features' }"
              >Features</router-link
            >
            <router-link :to="{ path: '/', hash: '#security' }"
              >Security</router-link
            >
            <router-link :to="{ path: '/', hash: '#download' }"
              >Download</router-link
            >
          </div>
          <div class="footer__col">
            <h2 class="footer__heading">Legal</h2>
            <router-link to="/legal">Privacy &amp; terms</router-link>
            <router-link to="/privacy">Privacy Policy</router-link>
            <router-link to="/terms">User Agreement</router-link>
            <router-link to="/cookies">Cookies &amp; website</router-link>
            <router-link to="/delete-account">Delete account</router-link>
          </div>
          <div class="footer__col">
            <h2 class="footer__heading">Get the app</h2>
            <a
              v-if="APP_STORE_URL"
              :href="APP_STORE_URL"
              target="_blank"
              rel="noopener"
              >App Store</a
            >
            <a :href="GOOGLE_PLAY_URL" target="_blank" rel="noopener"
              >Google Play</a
            >
            <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <p>© {{ year }} Allading. All rights reserved.</p>
        <nav class="footer__legal" aria-label="Legal">
          <router-link to="/privacy">Privacy Policy</router-link>
          <router-link to="/terms">User Agreement</router-link>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import icon from "@/assets/allading-icon.png";
import { APP_STORE_URL, GOOGLE_PLAY_URL, SUPPORT_EMAIL } from "@/content/links";

const year = new Date().getFullYear();
</script>

<style scoped>
.footer {
  background: var(--bg-secondary);
  color: var(--text);
  padding: 80px 0 calc(40px + env(safe-area-inset-bottom));
}

.footer__top {
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  gap: 48px;
  padding-bottom: 64px;
}

.footer__logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.footer__logo img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.footer__tagline {
  margin-top: 16px;
  max-width: 320px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.footer__cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 48px;
}

.footer__col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.footer__heading {
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
}

.footer__col a,
.footer__legal a {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  font-size: 13px;
  color: var(--text-secondary);
  transition: color 180ms ease;
  overflow-wrap: anywhere;
}

.footer__col a:hover,
.footer__legal a:hover {
  color: var(--text);
}

.footer__bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 24px;
  padding-top: 24px;
  border-top: 1px solid var(--border-light);
  font-size: 13px;
  color: var(--text-muted);
}

.footer__legal {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
}

@media (max-width: 1199px) {
  .footer__top {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .footer {
    padding-top: 64px;
  }
  .footer__cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px 16px;
  }
  .footer__col:last-child {
    grid-column: 1 / -1;
  }
  .footer__col a,
  .footer__legal a {
    min-height: 44px;
  }
}
</style>
